import { BOOKING_ACTION, updateDataSource } from ".";

export const toggleControl = (key, visible) => {
  return {
    type: BOOKING_ACTION.TOGGLE_DRAWER,
    payload: { key, visible }
  };
};

export const completeStep = step => {
  return {
    type: BOOKING_ACTION.COMPLETE_STEP,
    payload: { step }
  };
};

export const goToStep = step => (dispatch, getState) => {
  if (getState().booking.completedSteps.includes(step)) return;
  dispatch({ type: BOOKING_ACTION.GO_TO_STEP, payload: { step } });
};

export const goBackToStep = step => async (dispatch, getState) => {
  const { appointment, booking } = getState();
  if (booking.reload) {
    return;
  }
  const { completedSteps } = booking;
  const indexOfStep = completedSteps.indexOf(step);
  const remainingSteps = completedSteps.slice(0, indexOfStep + 1);
  const stepsToBeClear = completedSteps.slice(indexOfStep + 1);
  const newAppointmentDetail = stepsToBeClear.reduce((current, next) => {
    return {
      ...current,
      [next]: ""
    };
  }, appointment);

  dispatch({
    type: BOOKING_ACTION.GO_BACK_TO_STEP,
    payload: { steps: remainingSteps, appointment: newAppointmentDetail }
  });
  dispatch(updateDataSource("timeSlots", []));
};

export const reloadSteps = () => async dispatch => {
  dispatch({
    type: BOOKING_ACTION.RELOAD_STEPS,
    payload: { reload: true }
  });
  setTimeout(() => {
    dispatch({
      type: BOOKING_ACTION.RELOAD_STEPS,
      payload: { reload: false }
    });
  }, 600);
};

export const goToPage = page => {
  return {
    type: BOOKING_ACTION.GO_TO_PAGE,
    payload: { page }
  };
};

export const makeNewBooking = () => {
  return { type: BOOKING_ACTION.MAKE_NEW_BOOKING };
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/bookingActions.js